import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";
import "./HeroSlider.css";

const slides = [
  {
    id: 1,
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1600&auto=format&fit=crop&q=80",
    eyebrow: "END-TO-END TRANSACTION EXECUTION",
    title: "From Ideation",
    highlight: "To Deal Closing.",
    description:
      "We lead M&A, fundraise, end-to-end deal execution, handholding shareholders and management teams through complex end-to-end deal process.",
  },
  {
    id: 2,
    image:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1600&auto=format&fit=crop&q=80",
    eyebrow: "STRATEGIC PRIORITIES: FIRST 180 DAYS",
    title: "The First 180 Days ",
    highlight: "Define the Next 5 Years.",
    description:
      "The window right after a deal closes is where value creation starts or stalls. We embed from day one, turn the deal note into a 180-day plan, and drive it to completion.",
  },
  {
    id: 3,
    image:
      "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=1600&auto=format&fit=crop&q=80",
    eyebrow: "IPO Leadership",
    title: "Thought leaders for",
    highlight: "IPO process",
    description:
      "We are a boutique firm handholding shareholders and management teams through the IPO journey, right from ideation until listing.",
  },
  {
    id: 4,
    image:
      "https://images.unsplash.com/photo-1506869640319-fe1a24fd76dc?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    eyebrow: "POST-INVESTMENT VALUE CREATION",
    title: "The Fund Runs. ",
    highlight: "Deal Teams Stay Focused.",
    description:
      "We assist deal teams engage with their portfolio companies. We use a process driven approach and strong alignment between the deal team and management to get great outcomes.",
  },
  /*{
    id: 5,
    image:
      "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1600&auto=format&fit=crop&q=80",
    eyebrow: "Our Network",
    title: "Trusted",
    highlight: "Associations.",
    description: null,
    isLogos: true,
    centered: true,
    logos: [
      {
        name: "McKinsey & Company",
        logo: "/assets/logos/mckinsey.png",
        fallback: "McKinsey\n& Company",
        color: "#1C5C9B",
      },
      {
        name: "Deloitte",
        logo: "/assets/logos/deloitte.png",
        fallback: "Deloitte",
        color: "#86BC25",
      },
      {
        name: "PwC",
        logo: "/assets/logos/pwc.png",
        fallback: "PwC",
        color: "#D93954",
      },
      {
        name: "KPMG",
        logo: "/assets/logos/kpmg.png",
        fallback: "KPMG",
        color: "#00338D",
      },
      {
        name: "Goldman Sachs",
        logo: "/assets/logos/goldman-sachs.png",
        fallback: "Goldman\nSachs",
        color: "#6495C8",
      },
      {
        name: "JP Morgan",
        logo: "/assets/logos/jpmorgan.png",
        fallback: "JP Morgan",
        color: "#003087",
      },
      {
        name: "Bain & Co.",
        logo: "/assets/logos/bain.png",
        fallback: "Bain & Co.",
        color: "#CC0000",
      },
      {
        name: "BCG",
        logo: "/assets/logos/bcg.png",
        fallback: "BCG",
        color: "#00A94F",
      },
      {
        name: "Ernst & Young",
        logo: "/assets/logos/ey.png",
        fallback: "Ernst\n& Young",
        color: "#FFE600",
      },
      {
        name: "Morgan Stanley",
        logo: "/assets/logos/morgan-stanley.png",
        fallback: "Morgan\nStanley",
        color: "#0070CE",
      },
    ],
  },*/

];

const metrics = [
  { value: "50+", sub: "", label: "Private and Capital Market Transactions" },
  {
    value: "25+ ",
    sub: "",
    label: "Portfolio Companies Engaged With Outcomes",
  },
  { value: "100%", sub: "", label: "Referenceable Client Base" },
  { value: "7+", sub: "", label: "years of execution" },
];

const DURATION = 7000;

const LogoItem = ({ logo }) => {
  const [hasError, setHasError] = useState(false);

  return (
    <div className="slide-logo-item" style={{ "--logo-color": logo.color }}>
      <div className="slide-logo-wrapper">
        {hasError ? (
          <span className="slide-logo-fallback-text">
            {logo.fallback.split("\n").map((line, i) => (
              <span key={i}>{line}</span>
            ))}
          </span>
        ) : (
          <img
            src={logo.logo}
            alt={logo.name}
            className="slide-logo-img"
            onError={() => setHasError(true)}
            loading="lazy"
          />
        )}
      </div>
    </div>
  );
};

/* ── Play / Pause icon ── */
const PlayIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <polygon points="5,3 19,12 5,21" />
  </svg>
);

const PauseIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <rect x="5" y="3" width="4" height="18" rx="1" />
    <rect x="15" y="3" width="4" height="18" rx="1" />
  </svg>
);

/* ── Main slider ── */
const HeroSlider = () => {
  const [current, setCurrent] = useState(0);
  const [progress, setProgress] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const [tickerVisible, setTickerVisible] = useState(true);
  const intervalRef = useRef(null);

  const stopTimer = useCallback(() => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  }, []);

  const startTimer = useCallback(() => {
    stopTimer();
    intervalRef.current = setInterval(() => {
      setCurrent((c) => (c + 1) % slides.length);
      setProgress(0);
    }, DURATION);
  }, [stopTimer]);

  const goTo = useCallback(
    (idx) => {
      setCurrent(idx);
      setProgress(0);
      if (isPlaying) startTimer();
    },
    [isPlaying, startTimer],
  );

  const togglePlay = useCallback(() => {
    setIsPlaying((playing) => {
      if (playing) {
        stopTimer();
        setProgress(0);
      } else {
        startTimer();
      }
      return !playing;
    });
  }, [startTimer, stopTimer]);

  /* Auto-advance when playing */
  useEffect(() => {
    if (isPlaying) {
      startTimer();
    } else {
      stopTimer();
    }
    return stopTimer;
  }, [isPlaying, startTimer, stopTimer]);

  /* Progress bar */
  useEffect(() => {
    setProgress(0);
    if (!isPlaying) return;
    const t = setTimeout(() => setProgress(100), 60);
    return () => clearTimeout(t);
  }, [current, isPlaying]);

  const isCentered = slides[current]?.centered || false;

  return (
    <section className="hero-slider" aria-label="Hero banner">
      {/* ── Background slide images ── */}
      {slides.map((slide, i) => (
        <div
          key={slide.id}
          className={`hero-slide${i === current ? " active" : ""}`}
          aria-hidden={i !== current}
        >
          <div className="slide-img">
            <img src={slide.image} alt="" role="presentation" />
            <div
              className={`slide-img-overlay${
                slide.isLogos ? " slide-img-overlay--dark" : ""
              }`}
            />
          </div>
        </div>
      ))}

      <div className="hero-content-wrap">
        {slides.map((slide, i) => (
          <div
            key={slide.id}
            className={`slide-content-panel${i === current ? " active" : ""}${slide.centered ? " slide-content-panel--centered" : ""}`}
            aria-hidden={i !== current}
          >
            <span className="slide-eyebrow">{slide.eyebrow}</span>

            <h1 className="slide-heading">
              {slide.title}
              <br />
              <span className="slide-highlight">
                {i === current && (
                  <TypeAnimation
                    key={`${slide.id}-${current}`}
                    sequence={[slide.highlight]}
                    speed={200}
                    cursor={false}
                  />
                )}
              </span>
            </h1>

            {slide.isLogos ? (
              <div className="slide-logos-section">
                <div className="slide-logos-grid">
                  {slide.logos.map((logo, li) => (
                    <LogoItem key={li} logo={logo} />
                  ))}
                </div>
              </div>
            ) : (
              <>
                <p className="slide-desc">{slide.description}</p>
                {slide.id === 1 ? (
                  <div className="slide-btns">
                    <Link to="/services" className="hero-btn-primary">
                      What We Do
                    </Link>
                    <Link to="/contact" className="hero-btn-outline">
                      Let's Connect
                    </Link>
                  </div>
                ) : null}
              </>
            )}
          </div>
        ))}

        {/* Slide counter + dots + play/pause */}
        <div className="slider-controls">
          <button
            className="slider-play-btn"
            onClick={togglePlay}
            aria-label={isPlaying ? "Pause slideshow" : "Play slideshow"}
          >
            {isPlaying ? <PauseIcon /> : <PlayIcon />}
          </button>

          <div className="slider-dots">
            {slides.map((_, i) => (
              <button
                key={i}
                className={`slider-dot${i === current ? " active" : ""}`}
                onClick={() => goTo(i)}
                aria-label={`Go to slide ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* ── Right: metrics ticker (hide on centered slides) ── */}
      {tickerVisible && !isCentered && (
        <aside className="hero-ticker" aria-label="Key metrics">
          <div className="ticker-inner">
            {metrics.map((m, i) => (
              <div key={i} className="ticker-item">
                <span className="ticker-value">{m.value}</span>
                <span className="ticker-label">{m.label}</span>
                <span className="ticker-sub">{m.sub}</span>
              </div>
            ))}
          </div>
        </aside>
      )}

      {/* Ticker toggle (hide on centered slides) */}
      {!isCentered && (
        <button
          className="ticker-toggle-btn"
          onClick={() => setTickerVisible((v) => !v)}
          aria-label={
            tickerVisible ? "Hide metrics panel" : "Show metrics panel"
          }
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              transform: tickerVisible ? "rotate(0deg)" : "rotate(180deg)",
              transition: "transform 0.3s ease",
            }}
          >
            <path
              d="M9 18L15 12L9 6"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}

      {/* Progress bar */}
      <div
        className="slider-progress"
        style={{
          width: isPlaying ? `${progress}%` : "0%",
          transition:
            progress === 0 || !isPlaying
              ? "none"
              : `width ${DURATION}ms linear`,
        }}
      />
    </section>
  );
};

export default HeroSlider;